var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttention = function SvgAttention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 27.084C54 12.093 41.946.003 27 .003S0 12.19 0 27.084C0 41.98 12.054 54.166 27 54.166s27-12.09 27-27.082Zm-3.857 0c0 12.864-10.318 23.213-23.143 23.213-12.825 0-23.143-10.35-23.143-23.213C3.857 14.221 14.175 3.872 27 3.872c12.825 0 23.143 10.445 23.143 23.212Zm-22.68 7.433c-1.137 0-1.99-.855-1.99-1.995L25 15.132c0-1.14.853-2.09 1.99-2.09h.947c1.137 0 2.084.95 1.99 2.09l-.474 17.39c0 1.14-.853 1.995-1.99 1.995Zm0 7.032a2.467 2.467 0 0 0 2.463-2.47 2.467 2.467 0 0 0-2.463-2.471A2.467 2.467 0 0 0 25 39.078a2.467 2.467 0 0 0 2.463 2.47Z",
    fill: "currentColor"
  })));
};
export { SvgAttention as ReactComponent };
export default __webpack_public_path__ + "1532fa9424f6ff068f087fd447d33063.svg";